import React, { useContext } from "react";
import { Link } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import constext
import { GlobalProvider } from "context/GlobalContext";

const UserManagementBreadCrumb = () => {
  const { isUserListLoading } = useContext(GlobalProvider);

  const { t } = useTranslation(); //for translation

  // const glowCount = 5;
  return (
    <nav aria-label="breadcrumb">
      <ul className="breadcrumb mt-2">
        <li className="breadcrumb-item">
          <Link to="/" className="text-secondary">
            {t("Dashboard")}
          </Link>
        </li>
        <li className="breadcrumb-item text-gray-600" aria-current="page">
          {t("Users Management")}
        </li>
        {isUserListLoading && (
          <div className="d-flex align-items-center justify-content-center gap-2 mx-auto">
            <span>{t("Please wait")}</span>
            <p className="placeholder-glow" style={{ width: "300px" }}>
              <span className="d-block placeholder"></span>
            </p>
          </div>
        )}
      </ul>
    </nav>
  );
};

export default UserManagementBreadCrumb;
